<template>
  <main class="support page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('question.title') }}</h3>
    </section>

    <section class="support-center">
      <p class="description">
        {{ $t('question.center.description') }}
      </p>

      <ul class="tel">
        <html-view tag="li" :value="$t('question.center.list[0]')" />
        <html-view tag="li" :value="$t('question.center.list[1]')" />
      </ul>
    </section>

    <!--    <tab :tab-list="tabList" />-->
    <!--    <router-view />-->
  </main>
</template>
<script>
import defendPath from '@/mixins/defendPath'

export default {
  components: {
    // tab: () => import('@/components/base/Tab'),
  },
  mixins: [defendPath],
  data () {
    return {
      word: '',
      tabList: [
        { path: 'questionPartnership', name: 'question.tabPartnerships' },
        { path: 'questionPress', name: 'question.tabMedia' },
        // { path: 'questionCulture', name: 'question.tabCulture' },
        { path: 'questionOther', name: 'question.tabOther' }
      ]
    }
  },
}
</script>
